import React, { useEffect } from "react";
import { useAuth } from "./contexts/auth";

export default function () {
  const { loginUrl } = useAuth();

  useEffect(() => {
    window.location.href = loginUrl;
  }, [loginUrl]);

  return (
    <div className={`app`} style={{ justifyContent: "center" }}>
      <div>
        <h4 style={{ marginBottom: "0" }}> Unauthenticated</h4>
        <p style={{ textAlign: "center" }}>Redirecting to login...</p>
      </div>
    </div>
  );
}
